export const budgetSummary = {
  'Budget Summary': 'Resumo do orçamento',
  'Go to facial recognition': 'Seguir com reconhecimento facial',
  "Go to {{name}}'s facial recognition":
    'Seguir para reconhecimento facial de {{name}}',
  'Hello {{name}}!': 'Olá {{name}}!',
  'Legal guardian data': 'Dados do responsável legal',
  'Please, verify the information about your budget below to continue':
    'Por favor, verifique as informações do seu orçamento abaixo para prosseguir.',
  'Service taker data': 'Dados do tomador de serviço',
  'The facial recognition process must be performed by the legal guardian':
    'O processo de reconhecimento facial deve ser realizado pelo responsável legal',
  'We are very happy that you are on this journey with us! Please, verify the information about your budget below to continue':
    'Estamos muito felizes que você está conosco nessa jornada! Por favor, verifique as informações do seu orçamento abaixo para prosseguir.',
};
